import { ReactElement } from 'react';
import { dateToAge, getMessagingDate } from '@utils/timeHelpers';
import { ItemFields, UserData } from './types';
import { useTranslation } from 'react-i18next';

/**
* Build fields for User Information Page
* @param {UserData} userData - All data for user
* @param {ReactElement} mentorsSelect - Select for pick mentors
* @param {ReactElement} courseSelect - Select for pick course
* @param {ReactElement | null} businessUnitsSelect - Select for pick business units
* @param {ReactElement} statusSelect - Select for status
* @returns {Array<ItemFields>} - All fields for User Information Page
*/
export const userInformationFields = (
  userData: UserData,
  mentorsSelect: ReactElement,
  courseSelect: ReactElement,
  businessUnitsContent: ReactElement ,
  statusSelect: ReactElement,
  languageSelect: ReactElement,
  phoneContent: ReactElement | string,
  nameContent: ReactElement | string,
  birthdateContent: ReactElement | string,
): Array<ItemFields> => {
  const { t } = useTranslation();

  return [
    { id: 'email', label: <span>{t('Informative.Labels.email' as any)}</span>, content: userData.email },
    {
      id: 'phone',
      label: <span>{t('Authentication.MFA.phoneLabel')}</span>,
      content: phoneContent,
    },
    { id: 'userName', label: <span>{t('Informative.Labels.name' as any)}</span>, content: nameContent },
    { id: 'startDate', label: <span>{t('Informative.Labels.startDate' as any)}</span>, content: getMessagingDate(userData.createdAt) },
    { id: 'age', label: <span>{t('Informative.Labels.age' as any)}</span>, content: userData.birthdate && dateToAge(userData.birthdate) },
    { id: 'birthdate', label: <span>{t('Dates.birth' as any)}</span>, content: birthdateContent },
    { id: 'state', label: <span>{t('Informative.Labels.state' as any)}</span>, content: userData.countryState },
    { id: 'country', label: <span>{t('Informative.Labels.country' as any)}</span>, content: userData.country },
    { id: 'mentor', label: <span>{t('Informative.Labels.mentor' as any)}</span>, content: mentorsSelect },
    { id: 'course', label: <span>{t('Informative.Labels.course' as any)}</span>, content: courseSelect },
    { id: 'businessUnits', label: <span>{t('Informative.Labels.businessUnits' as any)}</span>, content: businessUnitsContent },
    { id: 'status', label: <span>{t('Informative.Labels.status' as any)}</span>, content: statusSelect },
    { id: 'language', label: <span>{t('Informative.Labels.language' as any)}</span>, content: languageSelect },
  ];
}
